// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.tbls-data {
  padding: 2px 15px;
  margin: 15px 0;
  border-bottom: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
  background-color: #fff;
}
form.charges-form {
  padding-top: 15px;
  margin: 15px 0;
  border-bottom: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
  background-color: #fff;
}
.fal {
  color: blue;
}
`, "",{"version":3,"sources":["webpack://./src/app/crimgrid-module/components/charge-data-list/charge-data-list.component.less"],"names":[],"mappings":"AAEA;EACI,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,6BAAA;EACA,sBAAA;AADJ;AAGA;EACI,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,6BAAA;EACA,sBAAA;AADJ;AAGA;EACI,WAAA;AADJ","sourcesContent":["@import (reference) url('../../../../assets/tables.less');\n\ndiv.tbls-data{\n    padding: 2px 15px;\n    margin: 15px 0;\n    border-bottom: 1px solid #e2e2e2;\n    border-top: 1px solid #e2e2e2;\n    background-color: #fff;\n}\nform.charges-form{\n    padding-top: 15px;\n    margin: 15px 0;\n    border-bottom: 1px solid #e2e2e2;\n    border-top: 1px solid #e2e2e2;\n    background-color: #fff;\n}\n.fal{\n    color: blue;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
